import { ApplicationConfig } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withViewTransitions } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtInterceptor } from './services/auth/jwt.interceptor';
import {provideMomentDateAdapter} from '@angular/material-moment-adapter';


export const appConfig: ApplicationConfig = {
  providers: [provideMomentDateAdapter(), provideRouter(routes, withViewTransitions(), withInMemoryScrolling({scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled'})), provideAnimationsAsync(), provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    }]
};